import * as Card from "@/components/ui/card"
import { Text } from "@/components/ui/text"
import { AlertCircle, CheckCircle } from "lucide-solid"
import { Flex } from "styled-system/jsx"

interface QuizResultBannerProps {
  allCorrect: boolean
}

export default function (props: QuizResultBannerProps) {
  return (
    <Card.Root
      p={6}
      bg={props.allCorrect ? 'jade.subtle' : 'red.subtle'}
      borderColor={props.allCorrect ? 'jade.default' : 'red.default'}
    >
      <Flex align="center" gap={3}>
        {props.allCorrect ? <CheckCircle color="var(--colors-jade-600)" /> : <AlertCircle color="var(--colors-red-600)" />}
        <Text textStyle="lg" fontWeight="medium">
          {props.allCorrect
            ? "Great job! You passed the quiz."
            : "You didn't quite get everything right. Let's review."}
        </Text>
      </Flex>
    </Card.Root>
  )
}
